import React from 'react';
import { Field } from 'react-final-form';
import { Select } from '@folio/stripes-components';
import { FormattedMessage, useIntl } from 'react-intl';
import useCustomFieldsCategories from '../../../../../../hooks/useCustomFieldsCategories';
import { required } from '../../../../../../utils/utils';

function CategoryField() {
  const { categories, isLoading } = useCustomFieldsCategories();
  const intl = useIntl();

  return (
    <>
      {!isLoading && (
        <Field
          component={Select}
          fullWidth
          name="categoryId"
          label={
            <FormattedMessage
              id="ui-plugin-inventory-templates.customFields.editForm.formFields.categoryId"
              defaultMessage="Category"
            />
          }
          dataOptions={[
            {
              label: intl.formatMessage({
                id: 'ui-plugin-inventory-templates.customFields.editForm.formFields.categoryId.choose',
                defaultMessage: 'Choose category name',
              }),
              value: '',
            },
            ...categories.map((category) => ({
              label: category?.name?.find(
                (field) => field?.locale === intl.locale,
              )?.value,
              value: category.id,
            })),
          ]}
          required
          validate={required}
          type="text"
        />
      )}
    </>
  );
}

export default CategoryField;
